function mapValuesToOptions<
  T extends {
    value: string
  },
  U extends string,
>(values: ReadonlyArray<U>, allOptions: T[]): T[] {
  const optionMap = new Map(allOptions.map((option) => [option.value, option]))
  return values.map((val) => optionMap.get(val)).filter((option): option is T => !!option)
}

export { mapValuesToOptions }
